import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ShortlistState {
    shortlistTab: string;
    selectedShortlistSortBy: string;
    shortListData: any[];
    shortCollegeList: any[];
    shortCourseList: any[];
    isLoading: boolean;
    hasMore: boolean;
    hasError: boolean;
    skipClgCount: number;
    skipCourseCount: number;
    addToListBtnHover: boolean;
    totalShortCollegeList: number;
    totalShortCourseList: number;
    showNothingCard: boolean;
    compared: any[];
    deadlineCollegeList: any[];

}

const initialState: ShortlistState = {
    shortlistTab: 'college',
    selectedShortlistSortBy: 'popularity',
    shortListData: [],
    shortCollegeList: [],
    shortCourseList: [],
    isLoading: false,
    hasMore: true,
    hasError: false,
    skipClgCount: 0,
    skipCourseCount: 0,
    addToListBtnHover: false,
    totalShortCollegeList: 0,
    totalShortCourseList: 0,
    showNothingCard: false,
    compared: [],
    deadlineCollegeList: []
}


const shortlistSlice = createSlice({
    name: 'shortlistData',
    initialState,
    reducers: {
        setShortlistTab: (state, action) => {
            state.shortlistTab = action.payload
        },
        setShortlistSortBy: (state, action) => {
            state.selectedShortlistSortBy = action.payload;
        },
        setShortlistData: (state, action) => {
            state.shortListData = action.payload;
        },
        setShortCollegeList: (state, action) => {
            state.shortCollegeList = action.payload;
        },
        setShortCourseList: (state, action) => {
            state.shortCourseList = action.payload;
        },
        setShortlistIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setShortlistHasMore: (state, action: PayloadAction<boolean>) => {
            state.hasMore = action.payload;
        },
        setShortlistHasError: (state, action: PayloadAction<boolean>) => {
            state.hasError = action.payload;
        },
        setShortClgSkipCount: (state, action: PayloadAction<number>) => {
            state.skipClgCount = action.payload;
        },
        setShortCourseSkipCount: (state, action: PayloadAction<number>) => {
            state.skipCourseCount = action.payload;
        },
        setTotalShortCollegeList: (state, action: PayloadAction<number>) => {
            state.totalShortCollegeList = action.payload;
        },
        setTotalShortCourseList: (state, action: PayloadAction<number>) => {
            state.totalShortCourseList = action.payload;
        },
        setAddToListBtnHover: (state, action: PayloadAction<boolean>) => {
            state.addToListBtnHover = action.payload;
        },
        setShowNothingCard: (state, action: PayloadAction<boolean>) => {
            state.showNothingCard = action.payload;
        },
        clearShortlist: () => initialState,
        updateShortlistStatus: (state, action) => {
            const { id, status } = action.payload;
            const list = state.shortListData;
            const updated = list.map(item => item._id === id ? { ...item, status } : item);
            state.shortListData = updated;
        },
        addToCompare: (state, action: PayloadAction<any>) => {
            const alreadyExists = state.compared.some(item => item._id === action.payload._id);
            if (!alreadyExists && state.compared.length < 3) {
                state.compared.push(action.payload);
            }
        },
        removeFromCompare: (state, action: PayloadAction<string>) => {
            state.compared = state.compared.filter(item => item._id !== action.payload);
        },
        clearCompareList: (state) => {
            state.compared = [];
        },
        setDeadlineCollegeList: (state, action) => {
            state.deadlineCollegeList = action.payload;
        },
    }
})

export const {
    setShortlistTab,
    setShortlistSortBy,
    setShortlistIsLoading,
    setShortlistHasMore,
    setShortlistHasError,
    setShortClgSkipCount,
    setShortCourseSkipCount,
    setAddToListBtnHover,
    setShortlistData,
    setShortCollegeList,
    setTotalShortCollegeList,
    setShortCourseList,
    setTotalShortCourseList,
    setShowNothingCard,
    clearShortlist,
    updateShortlistStatus,
    addToCompare,
    removeFromCompare,
    clearCompareList,
    setDeadlineCollegeList,

} = shortlistSlice.actions
export default shortlistSlice.reducer